import React  from 'react';

const Button = ({text, onClick}: {text: string, onClick: any}) => {
    return (
        <button onClick={onClick} className="min-w-[250px] sm:min-w-[100px] md:min-w-[250px] border border-[1px] border-white flex flex-col items-center justify-center uppercase text-white text-base sm:text-xxs lg:text-base font-untitledSans px-[50px] py-[8px]">{text}</button>
    );
};

export default Button;
